// Central currency configuration
// Change these values to update currency across the entire application

export const CURRENCY = {
  code: "GBP",
  symbol: "£",
  locale: "en-GB",
  stripeCode: "gbp"  // Stripe uses lowercase
};

// Format a price with the configured currency.
//
// Default behaviour: SHOW pence whenever the amount has a fractional part
// (e.g. £58.33), and HIDE pence when the amount is a whole number (e.g.
// £80). This matches how the clinic invoices read — most fees are round
// pounds, but discounted/split prices need to show the exact pence so
// admin reporting stays accurate.
//
// Override with `{decimals: 0}` or `{decimals: 2}` to force a specific style.
export const formatPrice = (amount, options = {}) => {
  if (amount === null || amount === undefined) return `${CURRENCY.symbol}0`;

  const num = Number(amount);
  const hasPence = Number.isFinite(num) && Math.abs(num - Math.round(num)) > 0.005;
  const { showCode = false, decimals = hasPence ? 2 : 0 } = options;

  const formatted = new Intl.NumberFormat(CURRENCY.locale, {
    style: 'currency',
    currency: CURRENCY.code,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(num);
  
  return showCode ? `${formatted} ${CURRENCY.code}` : formatted;
};

// Format price for display (shorthand)
export const price = (amount) => formatPrice(amount);

// Get raw symbol for inline use
export const currencySymbol = CURRENCY.symbol;
